import { FiChevronDown, FiDownload, FiFileText, FiImage } from 'react-icons/fi';
import MenuButton from './MenuButton';

export const downloadTypes = { CSV: 'CSV', IMAGE: 'IMAGE' };

const icons = {
    [downloadTypes.CSV]: FiFileText,
    [downloadTypes.IMAGE]: FiImage,
};

const defaultButtonProps = {
    IconLeft: FiDownload,
    IconRight: FiChevronDown,
    children: 'Export Data',
    size: 'sm',
};

function DownloadCSVMenuButton({
    buttonProps: buttonPropsProp,
    menuAlign = 'right',
    mixpanelContext = 'Download CSV',
    isDisabled,
    isLoading,
    options,
    ...props
}) {
    const buttonProps = { ...defaultButtonProps, ...buttonPropsProp };
    return (
        <MenuButton
            buttonProps={{
                ...buttonProps,
                isDisabled,
                fetching: isLoading,
            }}
            options={options.map(({ downloadType, ...option }) => ({
                ...(icons[downloadType] && { IconLeft: icons[downloadType] }),
                ...option,
            }))}
            menuAlign={menuAlign}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
}

export default DownloadCSVMenuButton;
